export default "__VITE_ASSET__Cm3hVUe6__"